import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 25,
	viewBox: "0 0 15 25",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 23.7546L14.5 1.24536C14.5 0.379591 13.4746 -0.0771012 12.831 0.502069L0.325883 11.7567C-0.115497 12.154 -0.115497 12.8461 0.325883 13.2433L12.831 24.4979C13.4746 25.0771 14.5 24.6204 14.5 23.7546Z",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
